import React from 'react';
import { Description, IconWrapper, Title, Wrapper } from './verification-success.styles';
import { IconTaskDone } from '@shared/icon/icon-task-done/icon-task-done';
import { Button } from '@vtbhome/juicyfront';
import { ROUTE_ADMIN_MAIN } from '@shared/config/routes/routes';
import { VerificationSuccessProps } from './types';
import { useDispatch } from 'react-redux';
import { setLogin } from '@features/current-user/login/model/slice';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';
import { setCredentials } from '@shared/lib/utils/credentials/credentials';

export const VerificationSuccess: React.FC<VerificationSuccessProps> = ({ response }) => {
    const redirect = useRedirect();
    const dispatch = useDispatch();

    const handleBeginWork = () => {
        dispatch(setLogin(response?.email));
        setCredentials({ accessToken: response.accessToken, refreshToken: response.refreshToken });
        redirect({ url: ROUTE_ADMIN_MAIN });
    };

    return (
        <Wrapper>
            <IconWrapper>
                <IconTaskDone />
            </IconWrapper>
            <Title size='h4'>Успешно!</Title>
            <Description size='subtitle1'>
                E-mail (<b>{response?.email}</b>) подтвержден.
            </Description>
            <Button fullWidth onClick={handleBeginWork}>
                Начать работу
            </Button>
        </Wrapper>
    );
};
